import './styles.scss';

import { Text } from '@fragments';
import { 
    IconBuildingBank, 
    IconChartLine, 
    IconInfoCircle 
} from '@tabler/icons-react';
import { useLocation } from 'react-router-dom';
import SidebarItem from '../_components/SidebarItem';
import config from '@config';

export default function AdminSection() {
    const location = useLocation();

    return (
        <div className="cs-admin-section">
            <div className="cs-sidebar-section-title">
                <Text.h6
                    contrast={6}
                    grow
                    weight={400}
                    className="mb-1 pl-1 mt-1"
                >
                    Administração
                </Text.h6>
            </div>

            <div className="admin-list">
                <SidebarItem
                    text="Banking"
                    left={<IconBuildingBank size={20} />}
                    onClick={() => window.navigate("/banking/charges")}
                    active={location.pathname.includes("/banking")}
                />
                <SidebarItem
                    text="Insights"
                    left={<IconChartLine size={20} />}
                    onClick={() => window.navigate("/insights")}
                    active={location.pathname.includes("/insights")}
                />
                <SidebarItem
                    text="Suporte"
                    left={<IconInfoCircle size={20} />}
                    onClick={() => window.open(config.help)}
                    active={location.pathname.includes("/support")}
                />
            </div>
        </div>
    )
}
